/**
 * This module's goal is to load any extensions that have been made to lodash and
 * incorporate them into the "_" namespace for access in the broader application.
 */
define(
    'extensions/lodash/mixins',[
        'lodash.base',
        'extensions/lodash/hasValue',
        'extensions/lodash/isInteger',
        'extensions/lodash/maybe'
    ],
    function (
        _,
        _hasValue,
        _isInteger,
        _maybe
    ) {
        'use strict';

        _.mixin(_hasValue);
        _.mixin(_isInteger);
        _.mixin(_maybe);

        return _;
    }
);

